<template>
  <div>
    <div v-show="!isMapData" style="width: 100vm; height: 500px;">
      <VChart :option="dataMapOption" autoresize :loading="isLoadingDataMap" @click="dataMapClick" />
    </div>
      <div class="search-result" v-show="isMapData">
        <span class="total">검색결과 <span class="num">{{ totalMapCnt }}</span>건</span>
          <div class="btn-layout right" >
            <button type="button" class="default btn" @click="showDataMap()" >데이터맵 보기</button>
          </div>
            <ul class="search-result-list">
              <li v-for="(data, idx) in staticsMapData" v-bind:key="idx">
                <a href="#/" @click="$parent.staticDetail(data.menuId, data.upPath)">
                  <div class="title-address">
                    <strong class="result-title">{{ data.title }} </strong>
                      <div class="address">
                        <span>{{ data.upPath }}</span>
                      </div>
                  </div>
                  <div class="result-date" v-if="data.termList[0] != null">
                    <p>{{ data.termList[0].startMonth }}<i>&nbsp;~&nbsp;</i>{{ data.termList[0].endMonth }}</p>
                  </div>
                </a>
              </li>
            </ul>
            <div class="btn-layout center" v-if="isMapSearchData" >
              <button type="button" class="line btn" @click="statisticsMapSearchList()">더보기</button>
            </div>
      </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import VChart from 'vue-echarts'
import * as api from '../../api/Search'
import * as staticApi from '../../api/Statistics'
import eChartOption from '../../assets/js/chartOption'

export default {
	name: 'DataMapChart',
	components: {
		VChart
	},
	props: {
		searchParams: {
			type: Array,
			required: true
		}
	},
	data () {
		return {
			dataMapChart: null,
			isLoadingDataMap: false,
			dataMapOption: {},
			dataMapLevelColors: ['#1C93D2', '#3DA481', '#FEBB41', '#D71159'],
			dataMapLinkColor: '#D71159',

			tblKorNmString: '',
			itmKorNmString: '',
			yearString: '',
			yearList: [],
			checkYearList: [],

			tblKorNm: '',
			upTblMgmNo: '',
			tblMgmNo: '',
			tblKorNmList1: [],
			tblKorNmList2: [],
			KorNmString1: '',
			KorNmString2: '',
			endSearchMap: '',
			staticsMapData: [],
			totalMapCnt: 0,
			MapCount: 10,
			MapPageIndex: 0,
			MapStartPage: 0,
			MapEndPage: 0,
			isMapSearchData: false, // 검색결과 더보기 보여줌 유무
			isMapData: false // false 데이터 맵 true검색 결과 나타남
		}
	},
	created () {
		// this.statisticsMapSearchList()
	},
	mounted () {
		this.searchDataMap()
	},
	destroyed () {
	},
	methods: {
		async dataMapClick (data) { // 데이터맵 마지막 level클릭했을 때
			if (data) {
				if (data.data.children.length == 0) { // 데이터 level3 데이터 값(더이상의 가지 없음)
					// console.log(data.data)
					// console.log(data.data.tblMgmNo)
					// console.log('click..', data.data.tblKorNm)

					this.MapPageIndex = 0
					this.MapStartPage = 0
					this.MapEndPage = 0
					this.staticsMapData = []

					this.tblMgmNo = data.data.tblMgmNo

					this.statisticsMapSearchList()
				}
				data.data.children.forEach(child => {
					this.addDataMapStyle(child, 1)
				})
			}
		},
		// 상세 검색 기능 아래 검색결과 화면 연결
		async statisticsMapSearchList (tblMgmNo) {
			this.MapPageIndex = this.MapPageIndex + 1
			this.MapStartPage = ((this.MapPageIndex - 1) * this.MapCount) + 1
			this.MapEndPage = this.MapPageIndex * this.MapCount

			if (tblMgmNo != '' && tblMgmNo != undefined) {
				this.tblMgmNo = tblMgmNo
			}

			const paramData = {
				startPage: this.MapStartPage,
				endPage: this.MapEndPage,
				tblMgmNo: this.tblMgmNo
			}

			// console.log(paramData)

			// const responseData = await staticApi.statisticsMapSearchList(paramData)//map용
			const responseData = await staticApi.statisticsList(paramData)

			const cntData = {
				tblMgmNo: this.tblMgmNo
			}

			const mapCnt = await staticApi.statisticsList(cntData)

			this.totalMapCnt = mapCnt.data.length

			if (responseData.data.length > 0) {
				responseData.data.forEach(data => this.staticsMapData.push(data))
				this.isMapData = true // 검색결과 화면 나오기

				if (responseData.data.length >= this.MapCount) {
					this.isMapSearchData = true // 검색결과 + 더보기 나오기
				} else {
					this.isMapSearchData = false// 더보기 안나오게
				}
			} else { // 하위 레벨이 없으면
				this.isMapData = false // 검색결과 안나오고 map 나오게
				this.isMapSearchData = false // 더보기도 안나오게
			}
		},
		showDataMap () {
			this.isMapData = false
		},
		async searchDataMap () { // 자동으로 데이터 맵 불러와짐
			this.isLoadingDataMap = true

			const search = { tblKorNm: '문화', tblMgmNo: 'STBL-1014250', children: this.searchParams }
			const searchData = await api.selectDataMap(search)

			if (searchData) {
				for (const data of searchData) {
					if (data.children) {
						this.addDataMapStyle(data, 1)
					}
				}

				const rootData = {
					name: '문화셈터',
					children: searchData,
					itemStyle: this.addItemStyle(0),
					lineStyle: this.addItemStyle(0)
				}

				this.dataMapOption = eChartOption.treeChart()
				this.dataMapOption.series[0].data[0] = rootData
				this.isLoadingDataMap = false
			}
		},
		addDataMapStyle (data, level) { // (00건) 값 추가?
			data.itemStyle = this.addItemStyle(level)

			if (data.children.length == 0) {
				data.name = data.name
			} else {
				data.name = data.name + ' (' + data.children.length + '건)'
			}

			if (data.children.length > 0) {
				data.children.forEach(child => {
					this.addDataMapStyle(child, level + 1)
				})
			}
		},
		addItemStyle (level) { // 맵 추가 될때 다른 색 가지 추가
			// console.log(level)
			return {
				color: this.dataMapLevelColors[level]
			}
		}
	}
}
</script>

<style scoped>
</style>
